import { BASE_PATH as i, BaseAPI as V, operationServerMap as p } from "../base.js";
import { DUMMY_BASE_URL as U, assertParamExists as d, createRequestFunction as v, serializeDataIfNeeded as y, setSearchParams as C, toPathString as I } from "../common.js";
import b from "axios";
var O = function(t) {
  return {
    merchantCustomerUserAdd: async (o, s = {}) => {
      d("merchantCustomerUserAdd", "merchantCustomerUserUpsertDTO", o);
      const n = new URL("/merchant_customer_user/create", U);
      let r;
      t && (r = t.baseOptions);
      const e = {
        method: "POST",
        ...r,
        ...s
      }, a = {}, m = {};
      a["Content-Type"] = "application/json", C(n, m);
      let l = r && r.headers ? r.headers : {};
      return e.headers = {
        ...a,
        ...l,
        ...s.headers
      }, e.data = y(o, e, t), {
        url: I(n),
        options: e
      };
    },
    merchantCustomerUserBatchUpdateMemberLevel: async (o, s = {}) => {
      d("merchantCustomerUserBatchUpdateMemberLevel", "batchUpdateMemberLevelDTO", o);
      const n = new URL("/merchant_customer_user/batch_update_level", U);
      let r;
      t && (r = t.baseOptions);
      const e = {
        method: "POST",
        ...r,
        ...s
      }, a = {}, m = {};
      a["Content-Type"] = "application/json", C(n, m);
      let l = r && r.headers ? r.headers : {};
      return e.headers = {
        ...a,
        ...l,
        ...s.headers
      }, e.data = y(o, e, t), {
        url: I(n),
        options: e
      };
    },
    merchantCustomerUserDeleteById: async (o, s = {}) => {
      d("merchantCustomerUserDeleteById", "merchantCustomerUserId", o);
      const n = "/merchant_customer_user/{merchantCustomerUserId}".replace("{merchantCustomerUserId}", encodeURIComponent(String(o))), r = new URL(n, U);
      let e;
      t && (e = t.baseOptions);
      const a = {
        method: "DELETE",
        ...e,
        ...s
      }, m = {};
      C(r, {});
      let l = e && e.headers ? e.headers : {};
      return a.headers = {
        ...m,
        ...l,
        ...s.headers
      }, {
        url: I(r),
        options: a
      };
    },
    merchantCustomerUserDeleteMember: async (o, s = {}) => {
      d("merchantCustomerUserDeleteMember", "memberIds", o);
      const n = new URL("/merchant_customer_user/delete", U);
      let r;
      t && (r = t.baseOptions);
      const e = {
        method: "DELETE",
        ...r,
        ...s
      }, a = {}, m = {};
      o && (m.memberIds = o), C(n, m);
      let l = r && r.headers ? r.headers : {};
      return e.headers = {
        ...a,
        ...l,
        ...s.headers
      }, {
        url: I(n),
        options: e
      };
    },
    merchantCustomerUserEdit: async (o, s = {}) => {
      d("merchantCustomerUserEdit", "merchantCustomerUserUpsertDTO", o);
      const n = new URL("/merchant_customer_user", U);
      let r;
      t && (r = t.baseOptions);
      const e = {
        method: "PUT",
        ...r,
        ...s
      }, a = {}, m = {};
      a["Content-Type"] = "application/json", C(n, m);
      let l = r && r.headers ? r.headers : {};
      return e.headers = {
        ...a,
        ...l,
        ...s.headers
      }, e.data = y(o, e, t), {
        url: I(n),
        options: e
      };
    },
    merchantCustomerUserGetByUserId: async (o, s = {}) => {
      d("merchantCustomerUserGetByUserId", "userId", o);
      const n = "/merchant_customer_user/get_by_user_id/{userId}".replace("{userId}", encodeURIComponent(String(o))), r = new URL(n, U);
      let e;
      t && (e = t.baseOptions);
      const a = {
        method: "GET",
        ...e,
        ...s
      }, m = {};
      C(r, {});
      let l = e && e.headers ? e.headers : {};
      return a.headers = {
        ...m,
        ...l,
        ...s.headers
      }, {
        url: I(r),
        options: a
      };
    },
    merchantCustomerUserGetEffectMemberRechargeRule: async (o, s = {}) => {
      d("merchantCustomerUserGetEffectMemberRechargeRule", "levelId", o);
      const n = new URL("/merchant_customer_user/effect/rule", U);
      let r;
      t && (r = t.baseOptions);
      const e = {
        method: "GET",
        ...r,
        ...s
      }, a = {}, m = {};
      o !== void 0 && (m.levelId = o), C(n, m);
      let l = r && r.headers ? r.headers : {};
      return e.headers = {
        ...a,
        ...l,
        ...s.headers
      }, {
        url: I(n),
        options: e
      };
    },
    merchantCustomerUserGetMemberDetailById: async (o, s = {}) => {
      d("merchantCustomerUserGetMemberDetailById", "memberId", o);
      const n = "/merchant_customer_user/detail/{memberId}".replace("{memberId}", encodeURIComponent(String(o))), r = new URL(n, U);
      let e;
      t && (e = t.baseOptions);
      const a = {
        method: "GET",
        ...e,
        ...s
      }, m = {};
      C(r, {});
      let l = e && e.headers ? e.headers : {};
      return a.headers = {
        ...m,
        ...l,
        ...s.headers
      }, {
        url: I(r),
        options: a
      };
    },
    merchantCustomerUserGetMemberDetailList: async (o, s, n = {}) => {
      d("merchantCustomerUserGetMemberDetailList", "shopId", o), d("merchantCustomerUserGetMemberDetailList", "phone", s);
      const r = "/merchant_customer_user/member_detail_list_by_phone/{shopId}/{phone}".replace("{shopId}", encodeURIComponent(String(o))).replace("{phone}", encodeURIComponent(String(s))), e = new URL(r, U);
      let a;
      t && (a = t.baseOptions);
      const m = {
        method: "GET",
        ...a,
        ...n
      }, l = {};
      C(e, {});
      let c = a && a.headers ? a.headers : {};
      return m.headers = {
        ...l,
        ...c,
        ...n.headers
      }, {
        url: I(e),
        options: m
      };
    },
    merchantCustomerUserGetMemberLevelListByShopId: async (o, s = {}) => {
      d("merchantCustomerUserGetMemberLevelListByShopId", "shopId", o);
      const n = "/merchant_customer_user/level/list/{shopId}".replace("{shopId}", encodeURIComponent(String(o))), r = new URL(n, U);
      let e;
      t && (e = t.baseOptions);
      const a = {
        method: "GET",
        ...e,
        ...s
      }, m = {};
      C(r, {});
      let l = e && e.headers ? e.headers : {};
      return a.headers = {
        ...m,
        ...l,
        ...s.headers
      }, {
        url: I(r),
        options: a
      };
    },
    merchantCustomerUserGetMemberList: async (o, s, n = {}) => {
      d("merchantCustomerUserGetMemberList", "shopId", o), d("merchantCustomerUserGetMemberList", "phone", s);
      const r = "/merchant_customer_user/member_list_by_phone/{shopId}/{phone}".replace("{shopId}", encodeURIComponent(String(o))).replace("{phone}", encodeURIComponent(String(s))), e = new URL(r, U);
      let a;
      t && (a = t.baseOptions);
      const m = {
        method: "GET",
        ...a,
        ...n
      }, l = {};
      C(e, {});
      let c = a && a.headers ? a.headers : {};
      return m.headers = {
        ...l,
        ...c,
        ...n.headers
      }, {
        url: I(e),
        options: m
      };
    },
    merchantCustomerUserGetMemberListBySearch: async (o, s = {}) => {
      d("merchantCustomerUserGetMemberListBySearch", "memberSearchInfoVO", o);
      const n = new URL("/merchant_customer_user/list_by_search", U);
      let r;
      t && (r = t.baseOptions);
      const e = {
        method: "POST",
        ...r,
        ...s
      }, a = {}, m = {};
      a["Content-Type"] = "application/json", C(n, m);
      let l = r && r.headers ? r.headers : {};
      return e.headers = {
        ...a,
        ...l,
        ...s.headers
      }, e.data = y(o, e, t), {
        url: I(n),
        options: e
      };
    },
    merchantCustomerUserGetMemberStatisticsByShopId: async (o, s = {}) => {
      d("merchantCustomerUserGetMemberStatisticsByShopId", "shopId", o);
      const n = "/merchant_customer_user/statistics/{shopId}".replace("{shopId}", encodeURIComponent(String(o))), r = new URL(n, U);
      let e;
      t && (e = t.baseOptions);
      const a = {
        method: "GET",
        ...e,
        ...s
      }, m = {};
      C(r, {});
      let l = e && e.headers ? e.headers : {};
      return a.headers = {
        ...m,
        ...l,
        ...s.headers
      }, {
        url: I(r),
        options: a
      };
    },
    merchantCustomerUserGetMemberStatisticsByShopId_1: async (o = {}) => {
      const s = new URL("/merchant_customer_user/member/statistics", U);
      let n;
      t && (n = t.baseOptions);
      const r = {
        method: "GET",
        ...n,
        ...o
      }, e = {};
      C(s, {});
      let a = n && n.headers ? n.headers : {};
      return r.headers = {
        ...e,
        ...a,
        ...o.headers
      }, {
        url: I(s),
        options: r
      };
    },
    merchantCustomerUserGetPage: async (o, s, n = {}) => {
      d("merchantCustomerUserGetPage", "merchantCustomerUser", o), d("merchantCustomerUserGetPage", "page", s);
      const r = new URL("/merchant_customer_user/page", U);
      let e;
      t && (e = t.baseOptions);
      const a = {
        method: "GET",
        ...e,
        ...n
      }, m = {}, l = {};
      if (o !== void 0) for (const [h, M] of Object.entries(o)) l[h] = M;
      if (s !== void 0) for (const [h, M] of Object.entries(s)) l[h] = M;
      C(r, l);
      let c = e && e.headers ? e.headers : {};
      return a.headers = {
        ...m,
        ...c,
        ...n.headers
      }, {
        url: I(r),
        options: a
      };
    },
    merchantCustomerUserGetUserInfo: async (o = {}) => {
      const s = new URL("/merchant_customer_user/get_user_info", U);
      let n;
      t && (n = t.baseOptions);
      const r = {
        method: "GET",
        ...n,
        ...o
      }, e = {};
      C(s, {});
      let a = n && n.headers ? n.headers : {};
      return r.headers = {
        ...e,
        ...a,
        ...o.headers
      }, {
        url: I(s),
        options: r
      };
    },
    merchantCustomerUserGetUserInfoByShopId: async (o, s = {}) => {
      d("merchantCustomerUserGetUserInfoByShopId", "shopId", o);
      const n = "/merchant_customer_user/get_user_info_by_shop_id/{shopId}".replace("{shopId}", encodeURIComponent(String(o))), r = new URL(n, U);
      let e;
      t && (e = t.baseOptions);
      const a = {
        method: "GET",
        ...e,
        ...s
      }, m = {};
      C(r, {});
      let l = e && e.headers ? e.headers : {};
      return a.headers = {
        ...m,
        ...l,
        ...s.headers
      }, {
        url: I(r),
        options: a
      };
    },
    merchantCustomerUserGetUserInfoByShopIdV2: async (o, s = {}) => {
      d("merchantCustomerUserGetUserInfoByShopIdV2", "shopId", o);
      const n = "/merchant_customer_user/get_user_info_by_shop_id_v2/{shopId}".replace("{shopId}", encodeURIComponent(String(o))), r = new URL(n, U);
      let e;
      t && (e = t.baseOptions);
      const a = {
        method: "GET",
        ...e,
        ...s
      }, m = {};
      C(r, {});
      let l = e && e.headers ? e.headers : {};
      return a.headers = {
        ...m,
        ...l,
        ...s.headers
      }, {
        url: I(r),
        options: a
      };
    },
    merchantCustomerUserImportMember: async (o, s = {}) => {
      d("merchantCustomerUserImportMember", "merchantCustomerUserDTO", o);
      const n = new URL("/merchant_customer_user/import", U);
      let r;
      t && (r = t.baseOptions);
      const e = {
        method: "POST",
        ...r,
        ...s
      }, a = {}, m = {};
      a["Content-Type"] = "application/json", C(n, m);
      let l = r && r.headers ? r.headers : {};
      return e.headers = {
        ...a,
        ...l,
        ...s.headers
      }, e.data = y(o, e, t), {
        url: I(n),
        options: e
      };
    },
    merchantCustomerUserImportMemberV2: async (o, s = {}) => {
      d("merchantCustomerUserImportMemberV2", "merchantCustomerUserDTO", o);
      const n = new URL("/merchant_customer_user/import_v2", U);
      let r;
      t && (r = t.baseOptions);
      const e = {
        method: "POST",
        ...r,
        ...s
      }, a = {}, m = {};
      a["Content-Type"] = "application/json", C(n, m);
      let l = r && r.headers ? r.headers : {};
      return e.headers = {
        ...a,
        ...l,
        ...s.headers
      }, e.data = y(o, e, t), {
        url: I(n),
        options: e
      };
    },
    merchantCustomerUserQueryById: async (o, s = {}) => {
      d("merchantCustomerUserQueryById", "merchantCustomerUserId", o);
      const n = "/merchant_customer_user/{merchantCustomerUserId}".replace("{merchantCustomerUserId}", encodeURIComponent(String(o))), r = new URL(n, U);
      let e;
      t && (e = t.baseOptions);
      const a = {
        method: "GET",
        ...e,
        ...s
      }, m = {};
      C(r, {});
      let l = e && e.headers ? e.headers : {};
      return a.headers = {
        ...m,
        ...l,
        ...s.headers
      }, {
        url: I(r),
        options: a
      };
    },
    merchantCustomerUserQueryMemberInfoByKeyword: async (o, s = {}) => {
      const n = new URL("/merchant_customer_user/search", U);
      let r;
      t && (r = t.baseOptions);
      const e = {
        method: "GET",
        ...r,
        ...s
      }, a = {}, m = {};
      o !== void 0 && (m.keyword = o), C(n, m);
      let l = r && r.headers ? r.headers : {};
      return e.headers = {
        ...a,
        ...l,
        ...s.headers
      }, {
        url: I(n),
        options: e
      };
    },
    merchantCustomerUserRegisterByCustomer: async (o, s = {}) => {
      d("merchantCustomerUserRegisterByCustomer", "merchantCustomerUserRegisterDTO", o);
      const n = new URL("/merchant_customer_user/register_by_customer", U);
      let r;
      t && (r = t.baseOptions);
      const e = {
        method: "POST",
        ...r,
        ...s
      }, a = {}, m = {};
      a["Content-Type"] = "application/json", C(n, m);
      let l = r && r.headers ? r.headers : {};
      return e.headers = {
        ...a,
        ...l,
        ...s.headers
      }, e.data = y(o, e, t), {
        url: I(n),
        options: e
      };
    },
    merchantCustomerUserSendMessageCaptcha: async (o, s = {}) => {
      d("merchantCustomerUserSendMessageCaptcha", "memberId", o);
      const n = new URL("/merchant_customer_user/captcha/send", U);
      let r;
      t && (r = t.baseOptions);
      const e = {
        method: "POST",
        ...r,
        ...s
      }, a = {}, m = {};
      o !== void 0 && (m.memberId = o), C(n, m);
      let l = r && r.headers ? r.headers : {};
      return e.headers = {
        ...a,
        ...l,
        ...s.headers
      }, {
        url: I(n),
        options: e
      };
    },
    merchantCustomerUserSwitchMemberStatus: async (o, s, n = {}) => {
      d("merchantCustomerUserSwitchMemberStatus", "memberId", o), d("merchantCustomerUserSwitchMemberStatus", "status", s);
      const r = "/merchant_customer_user/switch_status/{memberId}/{status}".replace("{memberId}", encodeURIComponent(String(o))).replace("{status}", encodeURIComponent(String(s))), e = new URL(r, U);
      let a;
      t && (a = t.baseOptions);
      const m = {
        method: "POST",
        ...a,
        ...n
      }, l = {};
      C(e, {});
      let c = a && a.headers ? a.headers : {};
      return m.headers = {
        ...l,
        ...c,
        ...n.headers
      }, {
        url: I(e),
        options: m
      };
    },
    merchantCustomerUserValidateMessageCaptcha: async (o, s, n = {}) => {
      d("merchantCustomerUserValidateMessageCaptcha", "id", o), d("merchantCustomerUserValidateMessageCaptcha", "captcha", s);
      const r = new URL("/merchant_customer_user/captcha/validate", U);
      let e;
      t && (e = t.baseOptions);
      const a = {
        method: "POST",
        ...e,
        ...n
      }, m = {}, l = {};
      o !== void 0 && (l.id = o), s !== void 0 && (l.captcha = s), C(r, l);
      let c = e && e.headers ? e.headers : {};
      return a.headers = {
        ...m,
        ...c,
        ...n.headers
      }, {
        url: I(r),
        options: a
      };
    }
  };
}, u = function(t) {
  const o = O(t);
  return {
    async merchantCustomerUserAdd(s, n) {
      var r, e;
      const a = await o.merchantCustomerUserAdd(s, n), m = (r = t == null ? void 0 : t.serverIndex) !== null && r !== void 0 ? r : 0, l = (e = p["MerchantCustomerUserApi.merchantCustomerUserAdd"]) === null || e === void 0 || (e = e[m]) === null || e === void 0 ? void 0 : e.url;
      return (c, h) => v(a, b, i, t)(c, l || h);
    },
    async merchantCustomerUserBatchUpdateMemberLevel(s, n) {
      var r, e;
      const a = await o.merchantCustomerUserBatchUpdateMemberLevel(s, n), m = (r = t == null ? void 0 : t.serverIndex) !== null && r !== void 0 ? r : 0, l = (e = p["MerchantCustomerUserApi.merchantCustomerUserBatchUpdateMemberLevel"]) === null || e === void 0 || (e = e[m]) === null || e === void 0 ? void 0 : e.url;
      return (c, h) => v(a, b, i, t)(c, l || h);
    },
    async merchantCustomerUserDeleteById(s, n) {
      var r, e;
      const a = await o.merchantCustomerUserDeleteById(s, n), m = (r = t == null ? void 0 : t.serverIndex) !== null && r !== void 0 ? r : 0, l = (e = p["MerchantCustomerUserApi.merchantCustomerUserDeleteById"]) === null || e === void 0 || (e = e[m]) === null || e === void 0 ? void 0 : e.url;
      return (c, h) => v(a, b, i, t)(c, l || h);
    },
    async merchantCustomerUserDeleteMember(s, n) {
      var r, e;
      const a = await o.merchantCustomerUserDeleteMember(s, n), m = (r = t == null ? void 0 : t.serverIndex) !== null && r !== void 0 ? r : 0, l = (e = p["MerchantCustomerUserApi.merchantCustomerUserDeleteMember"]) === null || e === void 0 || (e = e[m]) === null || e === void 0 ? void 0 : e.url;
      return (c, h) => v(a, b, i, t)(c, l || h);
    },
    async merchantCustomerUserEdit(s, n) {
      var r, e;
      const a = await o.merchantCustomerUserEdit(s, n), m = (r = t == null ? void 0 : t.serverIndex) !== null && r !== void 0 ? r : 0, l = (e = p["MerchantCustomerUserApi.merchantCustomerUserEdit"]) === null || e === void 0 || (e = e[m]) === null || e === void 0 ? void 0 : e.url;
      return (c, h) => v(a, b, i, t)(c, l || h);
    },
    async merchantCustomerUserGetByUserId(s, n) {
      var r, e;
      const a = await o.merchantCustomerUserGetByUserId(s, n), m = (r = t == null ? void 0 : t.serverIndex) !== null && r !== void 0 ? r : 0, l = (e = p["MerchantCustomerUserApi.merchantCustomerUserGetByUserId"]) === null || e === void 0 || (e = e[m]) === null || e === void 0 ? void 0 : e.url;
      return (c, h) => v(a, b, i, t)(c, l || h);
    },
    async merchantCustomerUserGetEffectMemberRechargeRule(s, n) {
      var r, e;
      const a = await o.merchantCustomerUserGetEffectMemberRechargeRule(s, n), m = (r = t == null ? void 0 : t.serverIndex) !== null && r !== void 0 ? r : 0, l = (e = p["MerchantCustomerUserApi.merchantCustomerUserGetEffectMemberRechargeRule"]) === null || e === void 0 || (e = e[m]) === null || e === void 0 ? void 0 : e.url;
      return (c, h) => v(a, b, i, t)(c, l || h);
    },
    async merchantCustomerUserGetMemberDetailById(s, n) {
      var r, e;
      const a = await o.merchantCustomerUserGetMemberDetailById(s, n), m = (r = t == null ? void 0 : t.serverIndex) !== null && r !== void 0 ? r : 0, l = (e = p["MerchantCustomerUserApi.merchantCustomerUserGetMemberDetailById"]) === null || e === void 0 || (e = e[m]) === null || e === void 0 ? void 0 : e.url;
      return (c, h) => v(a, b, i, t)(c, l || h);
    },
    async merchantCustomerUserGetMemberDetailList(s, n, r) {
      var e, a;
      const m = await o.merchantCustomerUserGetMemberDetailList(s, n, r), l = (e = t == null ? void 0 : t.serverIndex) !== null && e !== void 0 ? e : 0, c = (a = p["MerchantCustomerUserApi.merchantCustomerUserGetMemberDetailList"]) === null || a === void 0 || (a = a[l]) === null || a === void 0 ? void 0 : a.url;
      return (h, M) => v(m, b, i, t)(h, c || M);
    },
    async merchantCustomerUserGetMemberLevelListByShopId(s, n) {
      var r, e;
      const a = await o.merchantCustomerUserGetMemberLevelListByShopId(s, n), m = (r = t == null ? void 0 : t.serverIndex) !== null && r !== void 0 ? r : 0, l = (e = p["MerchantCustomerUserApi.merchantCustomerUserGetMemberLevelListByShopId"]) === null || e === void 0 || (e = e[m]) === null || e === void 0 ? void 0 : e.url;
      return (c, h) => v(a, b, i, t)(c, l || h);
    },
    async merchantCustomerUserGetMemberList(s, n, r) {
      var e, a;
      const m = await o.merchantCustomerUserGetMemberList(s, n, r), l = (e = t == null ? void 0 : t.serverIndex) !== null && e !== void 0 ? e : 0, c = (a = p["MerchantCustomerUserApi.merchantCustomerUserGetMemberList"]) === null || a === void 0 || (a = a[l]) === null || a === void 0 ? void 0 : a.url;
      return (h, M) => v(m, b, i, t)(h, c || M);
    },
    async merchantCustomerUserGetMemberListBySearch(s, n) {
      var r, e;
      const a = await o.merchantCustomerUserGetMemberListBySearch(s, n), m = (r = t == null ? void 0 : t.serverIndex) !== null && r !== void 0 ? r : 0, l = (e = p["MerchantCustomerUserApi.merchantCustomerUserGetMemberListBySearch"]) === null || e === void 0 || (e = e[m]) === null || e === void 0 ? void 0 : e.url;
      return (c, h) => v(a, b, i, t)(c, l || h);
    },
    async merchantCustomerUserGetMemberStatisticsByShopId(s, n) {
      var r, e;
      const a = await o.merchantCustomerUserGetMemberStatisticsByShopId(s, n), m = (r = t == null ? void 0 : t.serverIndex) !== null && r !== void 0 ? r : 0, l = (e = p["MerchantCustomerUserApi.merchantCustomerUserGetMemberStatisticsByShopId"]) === null || e === void 0 || (e = e[m]) === null || e === void 0 ? void 0 : e.url;
      return (c, h) => v(a, b, i, t)(c, l || h);
    },
    async merchantCustomerUserGetMemberStatisticsByShopId_1(s) {
      var n, r;
      const e = await o.merchantCustomerUserGetMemberStatisticsByShopId_1(s), a = (n = t == null ? void 0 : t.serverIndex) !== null && n !== void 0 ? n : 0, m = (r = p["MerchantCustomerUserApi.merchantCustomerUserGetMemberStatisticsByShopId_1"]) === null || r === void 0 || (r = r[a]) === null || r === void 0 ? void 0 : r.url;
      return (l, c) => v(e, b, i, t)(l, m || c);
    },
    async merchantCustomerUserGetPage(s, n, r) {
      var e, a;
      const m = await o.merchantCustomerUserGetPage(s, n, r), l = (e = t == null ? void 0 : t.serverIndex) !== null && e !== void 0 ? e : 0, c = (a = p["MerchantCustomerUserApi.merchantCustomerUserGetPage"]) === null || a === void 0 || (a = a[l]) === null || a === void 0 ? void 0 : a.url;
      return (h, M) => v(m, b, i, t)(h, c || M);
    },
    async merchantCustomerUserGetUserInfo(s) {
      var n, r;
      const e = await o.merchantCustomerUserGetUserInfo(s), a = (n = t == null ? void 0 : t.serverIndex) !== null && n !== void 0 ? n : 0, m = (r = p["MerchantCustomerUserApi.merchantCustomerUserGetUserInfo"]) === null || r === void 0 || (r = r[a]) === null || r === void 0 ? void 0 : r.url;
      return (l, c) => v(e, b, i, t)(l, m || c);
    },
    async merchantCustomerUserGetUserInfoByShopId(s, n) {
      var r, e;
      const a = await o.merchantCustomerUserGetUserInfoByShopId(s, n), m = (r = t == null ? void 0 : t.serverIndex) !== null && r !== void 0 ? r : 0, l = (e = p["MerchantCustomerUserApi.merchantCustomerUserGetUserInfoByShopId"]) === null || e === void 0 || (e = e[m]) === null || e === void 0 ? void 0 : e.url;
      return (c, h) => v(a, b, i, t)(c, l || h);
    },
    async merchantCustomerUserGetUserInfoByShopIdV2(s, n) {
      var r, e;
      const a = await o.merchantCustomerUserGetUserInfoByShopIdV2(s, n), m = (r = t == null ? void 0 : t.serverIndex) !== null && r !== void 0 ? r : 0, l = (e = p["MerchantCustomerUserApi.merchantCustomerUserGetUserInfoByShopIdV2"]) === null || e === void 0 || (e = e[m]) === null || e === void 0 ? void 0 : e.url;
      return (c, h) => v(a, b, i, t)(c, l || h);
    },
    async merchantCustomerUserImportMember(s, n) {
      var r, e;
      const a = await o.merchantCustomerUserImportMember(s, n), m = (r = t == null ? void 0 : t.serverIndex) !== null && r !== void 0 ? r : 0, l = (e = p["MerchantCustomerUserApi.merchantCustomerUserImportMember"]) === null || e === void 0 || (e = e[m]) === null || e === void 0 ? void 0 : e.url;
      return (c, h) => v(a, b, i, t)(c, l || h);
    },
    async merchantCustomerUserImportMemberV2(s, n) {
      var r, e;
      const a = await o.merchantCustomerUserImportMemberV2(s, n), m = (r = t == null ? void 0 : t.serverIndex) !== null && r !== void 0 ? r : 0, l = (e = p["MerchantCustomerUserApi.merchantCustomerUserImportMemberV2"]) === null || e === void 0 || (e = e[m]) === null || e === void 0 ? void 0 : e.url;
      return (c, h) => v(a, b, i, t)(c, l || h);
    },
    async merchantCustomerUserQueryById(s, n) {
      var r, e;
      const a = await o.merchantCustomerUserQueryById(s, n), m = (r = t == null ? void 0 : t.serverIndex) !== null && r !== void 0 ? r : 0, l = (e = p["MerchantCustomerUserApi.merchantCustomerUserQueryById"]) === null || e === void 0 || (e = e[m]) === null || e === void 0 ? void 0 : e.url;
      return (c, h) => v(a, b, i, t)(c, l || h);
    },
    async merchantCustomerUserQueryMemberInfoByKeyword(s, n) {
      var r, e;
      const a = await o.merchantCustomerUserQueryMemberInfoByKeyword(s, n), m = (r = t == null ? void 0 : t.serverIndex) !== null && r !== void 0 ? r : 0, l = (e = p["MerchantCustomerUserApi.merchantCustomerUserQueryMemberInfoByKeyword"]) === null || e === void 0 || (e = e[m]) === null || e === void 0 ? void 0 : e.url;
      return (c, h) => v(a, b, i, t)(c, l || h);
    },
    async merchantCustomerUserRegisterByCustomer(s, n) {
      var r, e;
      const a = await o.merchantCustomerUserRegisterByCustomer(s, n), m = (r = t == null ? void 0 : t.serverIndex) !== null && r !== void 0 ? r : 0, l = (e = p["MerchantCustomerUserApi.merchantCustomerUserRegisterByCustomer"]) === null || e === void 0 || (e = e[m]) === null || e === void 0 ? void 0 : e.url;
      return (c, h) => v(a, b, i, t)(c, l || h);
    },
    async merchantCustomerUserSendMessageCaptcha(s, n) {
      var r, e;
      const a = await o.merchantCustomerUserSendMessageCaptcha(s, n), m = (r = t == null ? void 0 : t.serverIndex) !== null && r !== void 0 ? r : 0, l = (e = p["MerchantCustomerUserApi.merchantCustomerUserSendMessageCaptcha"]) === null || e === void 0 || (e = e[m]) === null || e === void 0 ? void 0 : e.url;
      return (c, h) => v(a, b, i, t)(c, l || h);
    },
    async merchantCustomerUserSwitchMemberStatus(s, n, r) {
      var e, a;
      const m = await o.merchantCustomerUserSwitchMemberStatus(s, n, r), l = (e = t == null ? void 0 : t.serverIndex) !== null && e !== void 0 ? e : 0, c = (a = p["MerchantCustomerUserApi.merchantCustomerUserSwitchMemberStatus"]) === null || a === void 0 || (a = a[l]) === null || a === void 0 ? void 0 : a.url;
      return (h, M) => v(m, b, i, t)(h, c || M);
    },
    async merchantCustomerUserValidateMessageCaptcha(s, n, r) {
      var e, a;
      const m = await o.merchantCustomerUserValidateMessageCaptcha(s, n, r), l = (e = t == null ? void 0 : t.serverIndex) !== null && e !== void 0 ? e : 0, c = (a = p["MerchantCustomerUserApi.merchantCustomerUserValidateMessageCaptcha"]) === null || a === void 0 || (a = a[l]) === null || a === void 0 ? void 0 : a.url;
      return (h, M) => v(m, b, i, t)(h, c || M);
    }
  };
}, G = function(t, o, s) {
  const n = u(t);
  return {
    merchantCustomerUserAdd(r, e) {
      return n.merchantCustomerUserAdd(r.merchantCustomerUserUpsertDTO, e).then((a) => a(s, o));
    },
    merchantCustomerUserBatchUpdateMemberLevel(r, e) {
      return n.merchantCustomerUserBatchUpdateMemberLevel(r.batchUpdateMemberLevelDTO, e).then((a) => a(s, o));
    },
    merchantCustomerUserDeleteById(r, e) {
      return n.merchantCustomerUserDeleteById(r.merchantCustomerUserId, e).then((a) => a(s, o));
    },
    merchantCustomerUserDeleteMember(r, e) {
      return n.merchantCustomerUserDeleteMember(r.memberIds, e).then((a) => a(s, o));
    },
    merchantCustomerUserEdit(r, e) {
      return n.merchantCustomerUserEdit(r.merchantCustomerUserUpsertDTO, e).then((a) => a(s, o));
    },
    merchantCustomerUserGetByUserId(r, e) {
      return n.merchantCustomerUserGetByUserId(r.userId, e).then((a) => a(s, o));
    },
    merchantCustomerUserGetEffectMemberRechargeRule(r, e) {
      return n.merchantCustomerUserGetEffectMemberRechargeRule(r.levelId, e).then((a) => a(s, o));
    },
    merchantCustomerUserGetMemberDetailById(r, e) {
      return n.merchantCustomerUserGetMemberDetailById(r.memberId, e).then((a) => a(s, o));
    },
    merchantCustomerUserGetMemberDetailList(r, e) {
      return n.merchantCustomerUserGetMemberDetailList(r.shopId, r.phone, e).then((a) => a(s, o));
    },
    merchantCustomerUserGetMemberLevelListByShopId(r, e) {
      return n.merchantCustomerUserGetMemberLevelListByShopId(r.shopId, e).then((a) => a(s, o));
    },
    merchantCustomerUserGetMemberList(r, e) {
      return n.merchantCustomerUserGetMemberList(r.shopId, r.phone, e).then((a) => a(s, o));
    },
    merchantCustomerUserGetMemberListBySearch(r, e) {
      return n.merchantCustomerUserGetMemberListBySearch(r.memberSearchInfoVO, e).then((a) => a(s, o));
    },
    merchantCustomerUserGetMemberStatisticsByShopId(r, e) {
      return n.merchantCustomerUserGetMemberStatisticsByShopId(r.shopId, e).then((a) => a(s, o));
    },
    merchantCustomerUserGetMemberStatisticsByShopId_1(r) {
      return n.merchantCustomerUserGetMemberStatisticsByShopId_1(r).then((e) => e(s, o));
    },
    merchantCustomerUserGetPage(r, e) {
      return n.merchantCustomerUserGetPage(r.merchantCustomerUser, r.page, e).then((a) => a(s, o));
    },
    merchantCustomerUserGetUserInfo(r) {
      return n.merchantCustomerUserGetUserInfo(r).then((e) => e(s, o));
    },
    merchantCustomerUserGetUserInfoByShopId(r, e) {
      return n.merchantCustomerUserGetUserInfoByShopId(r.shopId, e).then((a) => a(s, o));
    },
    merchantCustomerUserGetUserInfoByShopIdV2(r, e) {
      return n.merchantCustomerUserGetUserInfoByShopIdV2(r.shopId, e).then((a) => a(s, o));
    },
    merchantCustomerUserImportMember(r, e) {
      return n.merchantCustomerUserImportMember(r.merchantCustomerUserDTO, e).then((a) => a(s, o));
    },
    merchantCustomerUserImportMemberV2(r, e) {
      return n.merchantCustomerUserImportMemberV2(r.merchantCustomerUserDTO, e).then((a) => a(s, o));
    },
    merchantCustomerUserQueryById(r, e) {
      return n.merchantCustomerUserQueryById(r.merchantCustomerUserId, e).then((a) => a(s, o));
    },
    merchantCustomerUserQueryMemberInfoByKeyword(r = {}, e) {
      return n.merchantCustomerUserQueryMemberInfoByKeyword(r.keyword, e).then((a) => a(s, o));
    },
    merchantCustomerUserRegisterByCustomer(r, e) {
      return n.merchantCustomerUserRegisterByCustomer(r.merchantCustomerUserRegisterDTO, e).then((a) => a(s, o));
    },
    merchantCustomerUserSendMessageCaptcha(r, e) {
      return n.merchantCustomerUserSendMessageCaptcha(r.memberId, e).then((a) => a(s, o));
    },
    merchantCustomerUserSwitchMemberStatus(r, e) {
      return n.merchantCustomerUserSwitchMemberStatus(r.memberId, r.status, e).then((a) => a(s, o));
    },
    merchantCustomerUserValidateMessageCaptcha(r, e) {
      return n.merchantCustomerUserValidateMessageCaptcha(r.id, r.captcha, e).then((a) => a(s, o));
    }
  };
}, A = class extends V {
  merchantCustomerUserAdd(t, o) {
    return u(this.configuration).merchantCustomerUserAdd(t.merchantCustomerUserUpsertDTO, o).then((s) => s(this.axios, this.basePath));
  }
  merchantCustomerUserBatchUpdateMemberLevel(t, o) {
    return u(this.configuration).merchantCustomerUserBatchUpdateMemberLevel(t.batchUpdateMemberLevelDTO, o).then((s) => s(this.axios, this.basePath));
  }
  merchantCustomerUserDeleteById(t, o) {
    return u(this.configuration).merchantCustomerUserDeleteById(t.merchantCustomerUserId, o).then((s) => s(this.axios, this.basePath));
  }
  merchantCustomerUserDeleteMember(t, o) {
    return u(this.configuration).merchantCustomerUserDeleteMember(t.memberIds, o).then((s) => s(this.axios, this.basePath));
  }
  merchantCustomerUserEdit(t, o) {
    return u(this.configuration).merchantCustomerUserEdit(t.merchantCustomerUserUpsertDTO, o).then((s) => s(this.axios, this.basePath));
  }
  merchantCustomerUserGetByUserId(t, o) {
    return u(this.configuration).merchantCustomerUserGetByUserId(t.userId, o).then((s) => s(this.axios, this.basePath));
  }
  merchantCustomerUserGetEffectMemberRechargeRule(t, o) {
    return u(this.configuration).merchantCustomerUserGetEffectMemberRechargeRule(t.levelId, o).then((s) => s(this.axios, this.basePath));
  }
  merchantCustomerUserGetMemberDetailById(t, o) {
    return u(this.configuration).merchantCustomerUserGetMemberDetailById(t.memberId, o).then((s) => s(this.axios, this.basePath));
  }
  merchantCustomerUserGetMemberDetailList(t, o) {
    return u(this.configuration).merchantCustomerUserGetMemberDetailList(t.shopId, t.phone, o).then((s) => s(this.axios, this.basePath));
  }
  merchantCustomerUserGetMemberLevelListByShopId(t, o) {
    return u(this.configuration).merchantCustomerUserGetMemberLevelListByShopId(t.shopId, o).then((s) => s(this.axios, this.basePath));
  }
  merchantCustomerUserGetMemberList(t, o) {
    return u(this.configuration).merchantCustomerUserGetMemberList(t.shopId, t.phone, o).then((s) => s(this.axios, this.basePath));
  }
  merchantCustomerUserGetMemberListBySearch(t, o) {
    return u(this.configuration).merchantCustomerUserGetMemberListBySearch(t.memberSearchInfoVO, o).then((s) => s(this.axios, this.basePath));
  }
  merchantCustomerUserGetMemberStatisticsByShopId(t, o) {
    return u(this.configuration).merchantCustomerUserGetMemberStatisticsByShopId(t.shopId, o).then((s) => s(this.axios, this.basePath));
  }
  merchantCustomerUserGetMemberStatisticsByShopId_1(t) {
    return u(this.configuration).merchantCustomerUserGetMemberStatisticsByShopId_1(t).then((o) => o(this.axios, this.basePath));
  }
  merchantCustomerUserGetPage(t, o) {
    return u(this.configuration).merchantCustomerUserGetPage(t.merchantCustomerUser, t.page, o).then((s) => s(this.axios, this.basePath));
  }
  merchantCustomerUserGetUserInfo(t) {
    return u(this.configuration).merchantCustomerUserGetUserInfo(t).then((o) => o(this.axios, this.basePath));
  }
  merchantCustomerUserGetUserInfoByShopId(t, o) {
    return u(this.configuration).merchantCustomerUserGetUserInfoByShopId(t.shopId, o).then((s) => s(this.axios, this.basePath));
  }
  merchantCustomerUserGetUserInfoByShopIdV2(t, o) {
    return u(this.configuration).merchantCustomerUserGetUserInfoByShopIdV2(t.shopId, o).then((s) => s(this.axios, this.basePath));
  }
  merchantCustomerUserImportMember(t, o) {
    return u(this.configuration).merchantCustomerUserImportMember(t.merchantCustomerUserDTO, o).then((s) => s(this.axios, this.basePath));
  }
  merchantCustomerUserImportMemberV2(t, o) {
    return u(this.configuration).merchantCustomerUserImportMemberV2(t.merchantCustomerUserDTO, o).then((s) => s(this.axios, this.basePath));
  }
  merchantCustomerUserQueryById(t, o) {
    return u(this.configuration).merchantCustomerUserQueryById(t.merchantCustomerUserId, o).then((s) => s(this.axios, this.basePath));
  }
  merchantCustomerUserQueryMemberInfoByKeyword(t = {}, o) {
    return u(this.configuration).merchantCustomerUserQueryMemberInfoByKeyword(t.keyword, o).then((s) => s(this.axios, this.basePath));
  }
  merchantCustomerUserRegisterByCustomer(t, o) {
    return u(this.configuration).merchantCustomerUserRegisterByCustomer(t.merchantCustomerUserRegisterDTO, o).then((s) => s(this.axios, this.basePath));
  }
  merchantCustomerUserSendMessageCaptcha(t, o) {
    return u(this.configuration).merchantCustomerUserSendMessageCaptcha(t.memberId, o).then((s) => s(this.axios, this.basePath));
  }
  merchantCustomerUserSwitchMemberStatus(t, o) {
    return u(this.configuration).merchantCustomerUserSwitchMemberStatus(t.memberId, t.status, o).then((s) => s(this.axios, this.basePath));
  }
  merchantCustomerUserValidateMessageCaptcha(t, o) {
    return u(this.configuration).merchantCustomerUserValidateMessageCaptcha(t.id, t.captcha, o).then((s) => s(this.axios, this.basePath));
  }
};
export {
  A as MerchantCustomerUserApi,
  O as MerchantCustomerUserApiAxiosParamCreator,
  G as MerchantCustomerUserApiFactory,
  u as MerchantCustomerUserApiFp
};

//# sourceMappingURL=merchant-customer-user-api.js.map